// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__E4dtW","rootSuccess":"CompleteLink_rootSuccess__1vtVd","rootFailure":"CompleteLink_rootFailure__1FSU7","isDisabled":"CompleteLink_isDisabled__KSWMJ"};